<template>
<div class="table-pane">
  <el-select v-model="table_list" multiple clearable @change="initChange">
    <el-option
      v-for="item in list"
      :key="item"
      :label="item"
      :value="item">
    </el-option>
  </el-select>
</div>
</template>

<script>
export default {
  name: "SelelctTables",
  props:{
    tableList:{
      type:Array,
      default(){
        return[]
      }
    }
  },
  model:{
    prop:"tableList",
    event:"success",
  },
  data(){
    return{
      table_list:[],
      list:[
        "bpm_qj",
        "hr_attachment",
        "hr_department",
        "hr_flow_form",
        "hr_flow_inst_form",
        "hr_flow_master",
        "hr_flow_message",
        "hr_flow_model",
        "hr_flow_process_steps",
        "hr_flow_sheet",
        "hr_position",
        "hr_test",
        "hr_user",
        "hr_user_role",
        "hr_xsc_system_users",
      ]
    }
  },
  mounted() {
    this.initData()
  },
  watch:{
    tableList(){
      this.initData()
    }
  },
  methods:{
    initData(){
      var that=this;
      that.table_list=JSON.parse(JSON.stringify(that.tableList));
    },
    initChange(){
      this.$emit('success',this.table_list)
    },
  }
}
</script>

<style lang="scss" scoped>
.table-pane{
  position: absolute;
  left: 5px;
  top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Database/components/SelelctTables.vue